import logoWhite from "./assets/rio_logo_white.png";
import logoBlack from "./assets/rio_logo_black.png";
import type { MouseEvent } from "react";
import { navigateToView } from "../../utils/appRoutes";

interface CompanyLogoProps {
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
  clickable?: boolean;
  variant?: "auto" | "light" | "dark";
  showText?: boolean;
  compact?: boolean;
}

export function CompanyLogo({
  size = "md",
  className = "",
  clickable = false,
  variant = "auto",
  compact = false,
}: CompanyLogoProps) {
  const sizeClasses = {
    sm: "h-7 sm:h-8 max-w-[120px]",
    md: "h-9 sm:h-10 max-w-[160px]",
    lg: "h-12 sm:h-14 max-w-[200px]",
    xl: "h-16 sm:h-20 max-w-[260px]",
  };

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    event.preventDefault();
    navigateToView("dashboard");
  };

  const logo = compact ? (
    <span
      className="flex size-10 shrink-0 items-center justify-center rounded-xl border border-white/15 bg-white/[0.08] text-[13px] font-black tracking-[-0.08em] text-white shadow-sm"
      aria-label="RIO Project Management"
    >
      RIO
    </span>
  ) : (
    <>
      {variant === "dark" ? (
        <img
          src={logoWhite}
          alt="RIO Project Management Logo"
          width={1729}
          height={666}
          className={`${sizeClasses[size]} w-auto object-contain`}
        />
      ) : variant === "light" ? (
        <img
          src={logoBlack}
          alt="RIO Project Management Logo"
          width={1729}
          height={666}
          className={`${sizeClasses[size]} w-auto object-contain`}
        />
      ) : (
        <>
          <img
            src={logoBlack}
            alt="RIO Project Management Logo"
            width={1729}
            height={666}
            className={`${sizeClasses[size]} w-auto object-contain dark:hidden`}
          />
          <img
            src={logoWhite}
            alt="RIO Project Management Logo"
            width={1729}
            height={666}
            className={`${sizeClasses[size]} w-auto object-contain hidden dark:block`}
          />
        </>
      )}
    </>
  );

  if (clickable) {
    return (
      <a
        href="/dashboard"
        onClick={handleClick}
        className={`flex items-center rounded-lg transition-opacity hover:opacity-85 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70 ${className}`}
        aria-label="Go to dashboard"
      >
        {logo}
      </a>
    );
  }

  return (
    <div className={`flex items-center ${className}`}>
      {logo}
    </div>
  );
}
